import { WithApplicationFromRoute } from '@features/applications/components/with-application-from-route.tsx';
import ServiceUnavailableStep from '@features/wizard/components/service-unavailable/service-unavailable-step.tsx';

const ServiceUnavailablePage = WithApplicationFromRoute(ServiceUnavailableStep);

export default ServiceUnavailablePage;
